import { config } from '../../config';
import objectAssignDeep from 'object-assign-deep';

const removeNullValues = (obj) =>
  JSON.parse(JSON.stringify(obj, (k, v) => (v === '' ? undefined : v)));
export const createTestAppData = (t: any, appData): Promise<any> => {
  const compactAppData = removeNullValues(appData);

  const defaultData = {
    baseInfo: {
      name: t('solution.test-app.name'),
      teaser: t('solution.test-app.teaser'),
      icon: `${config.marketplaceStaticsUrl}assets/images/app-logo-empty.svg`,
      description: t('solution.test-app.description'),
      company: {
        name: t('solution.test-app.company'),
      },
      reviewStars: 0,
      numberOfReviews: 0,
    },
    webSolutionData: {
      appData: {
        benefits: [],
      },
    },
    assetsMap: {
      appIcon: {
        assets: [
          {
            url: `${config.marketplaceStaticsUrl}assets/images/app-logo-empty.svg`,
            mediaType: 'IMAGE',
          },
        ],
      },
      banners: {
        assets: [{}],
      },
      screenshots: {
        assets: [
          {
            url: `${config.marketplaceStaticsUrl}assets/images/empty-gallery.svg`,
            mediaType: 'IMAGE',
          },
        ],
      },
      galleryVideos: {
        assets: [{}],
      },
    },
    company: {
      companyBase: {
        name: t('solution.test-app.company'),
      },
      assetsMap: {
        companyIcon: {
          assets: [{}],
        },
      },
      website: t('solution.test-app.company-website'),
      supportEmail: t('Support Email Link'),
      reviewStars: 0,
      numberOfReviews: 0,
      privacyPolicyUrl: t('solution.test-app.company-Privacy'),
    },
  };
  return objectAssignDeep(defaultData, compactAppData);
};
